/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login-page[_ngcontent-%COMP%]{background:0 0}.login-logo[_ngcontent-%COMP%]{font-size:initial;font-weight:400;margin-bottom:20px;fill:#fff}.login-box-body[_ngcontent-%COMP%]{background:#fff;border-radius:10px}.toggle-mode[_ngcontent-%COMP%]{font-weight:700;text-transform:uppercase}"];
export { styles as styles };
